import api from '@/services/api';

export type SiteAccessStatus = 'granted' | 'blocked';

export interface UserSiteAccessItem {
  id: number;
  node_id: string;
  node_serial: string;
  user_serial: string;
  status: SiteAccessStatus;
  user_type: string;
  permission_profile_id?: number | null;
  permission_profile_name?: string;
  /** RadFlow: Marcar como borrador (permiso remoto). Default true si omite. */
  use_draft?: boolean;
  /** RadFlow: Firmar estudio (permiso remoto). Default true si omite. */
  allow_sign?: boolean;
  /** RadFlow: reabrir/editar informes firmados. Default true si omite. */
  allow_edit?: boolean;
  /** Solo estudios con serial en assigned_serials. */
  only_assigned?: boolean;
  /** Puede tomar casos fuera del pool de assigned_serials. */
  can_take_unassigned?: boolean;
  /** Debe tomar el caso antes de informar. */
  require_take_before_report?: boolean;
  /** Solo estudios cuyo referring_physician_name contiene dicom_ref. */
  dicom_ref_enabled?: boolean;
  /** Texto a buscar en referring_physician_name. */
  dicom_ref?: string;
  /** UUID de instalación Flutter titular; vacío = sin restricción de estación. */
  app_id?: string[];
  /** Horas tras firmar para poder editar; 0 = sin límite. */
  edit_time_limit_hours?: number;
  last_event: string;
  event_ts?: string | null;
  last_synced_at: string;
  created_at: string;
  updated_at: string;
  site_name: string;
  center_name: string;
  center_short_name: string;
  center_slogan?: string;
  center_tel?: string;
  center_address?: string;
  center_email?: string;
  center_web?: string;
  url_remote?: string;
  internet_status?: string;
  last_identity_at?: string | null;
  node_known: boolean;
  /** User-defined hex color (#RRGGBB) for this site. */
  color?: string;
  /** Monitor template flags (present for MONITOR /users/me/sites). */
  view_site_info?: boolean;
  view_patients?: boolean;
  view_studies?: boolean;
  view_reports?: boolean;
}

export interface UserSiteAccessListResponse {
  user_serial: string;
  items: UserSiteAccessItem[];
  total: number;
  granted: number;
  blocked: number;
}

export async function fetchMySites(): Promise<UserSiteAccessListResponse> {
  const { data } = await api.get<UserSiteAccessListResponse>('/users/me/sites');
  return {
    user_serial: data.user_serial || '',
    items: data.items || [],
    total: data.total ?? 0,
    granted: data.granted ?? 0,
    blocked: data.blocked ?? 0,
  };
}

export async function updateMySiteColor(
  nodeId: string,
  color: string,
): Promise<{ node_id: string; color: string }> {
  const { data } = await api.patch<{ node_id: string; color: string }>(
    `/users/me/sites/${encodeURIComponent(nodeId)}/color`,
    { color },
  );
  return data;
}
